import { Avatar, Group, Text } from '@mantine/core';

type Props = {
    src?: string | null;
    name: string;
    subtitle?: string | null;
    /** Third line under the subtitle, for a city or address stacked in a tight row. */
    detail?: string | null;
    /** Squared thumb for places/covers; circle for people/partners. */
    radius?: 'xl' | 'md' | 'sm';
};

/** Avatar + primary/secondary text — same pattern as Authors table. */
export const EntityThumb = ({ src, name, subtitle, detail, radius = 'xl' }: Props) => (
    <Group gap='sm' wrap='nowrap' style={{ maxWidth: '100%' }}>
        <Avatar src={src || undefined} radius={radius} size={32} style={{ flex: '0 0 auto' }}>
            {(name || '?').slice(0, 1).toUpperCase()}
        </Avatar>
        <div style={{ minWidth: 0, flex: '1 1 auto', overflow: 'hidden' }}>
            <Text size='sm' fw={600} truncate>
                {name}
            </Text>
            {subtitle ? (
                <Text size='xs' c='dimmed' lineClamp={1}>
                    {subtitle}
                </Text>
            ) : null}
            {detail ? (
                <Text size='xs' c='dimmed' lineClamp={1}>
                    {detail}
                </Text>
            ) : null}
        </div>
    </Group>
);
